import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  constructor() {}
  loading = signal<boolean>(true);

  start() {
    this.loading.update(() => {
      return true;
    });
  }

  stop() {
    this.loading.update(() => {
      return false;
    });
  }
}
